import React, { useState, useEffect,useRef } from "react";
import axios from "axios";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import DynamicForm from '../common/DynamicForm';
import LoaderComponent from "../../../libraries/loader/loader";
import { Fetchexecutequery, Fetchheaderdata,Fetchupdatequery,Fetchfileupload,FetchsavePIRows } from '../../../services/process/BRS1/brsService7';
import { CreateData} from '../../../services/process/process_data/process_data';
import { Icon } from 'semantic-ui-react';
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import excelIcon from '../../../assets/images/excel.png'; // Ensure these icons exist
import pdfIcon from '../../../assets/images/pdf.png';
import logo from '../../../assets/images/1.png'; // Adjust the path to your image
import jsPDF from 'jspdf';
import 'jspdf-autotable';


function PoCreation() {
  const [formData, setFormData] = useState({});
  const [formData2, setFormData2] = useState({});
  const [activeTab, setActiveTab] = useState(0);
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
  const divisionid = userCredentials.division.join(",");
  const [fields, setFields] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [rowData1, setRowData1] = useState([]);
  const [rowData2, setRowData2] = useState([]);
  const [rowData3, setRowData3] = useState([]);
  const [fields1, setFields1] = useState(null);
  const [fields2, setFields2] = useState(null);
  const [fields3, setFields3] = useState(null);
  const [columnDefs, setColumnDefs] = useState([]);
  const [columnDefs1, setColumnDefs1] = useState([]);
  const [columnDefs2, setColumnDefs2] = useState([]);
  const [columnDefs3, setColumnDefs3] = useState([]);
  const [isDiv1Open, setIsDiv1Open] = useState(true);
  const [isDiv2Open, setIsDiv2Open] = useState(false);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState('');
  const [error, setError] = useState(null);
  const [showPopup, setShowPopup] = useState(false );
  const [filterconditions,setFilterconditions] =  useState([{"is_active" : 1,"entity_id" : userCredentials.selectedentity,"tenant_id": userCredentials.tenants_id,"group_id": userCredentials.groups_id}]);
  const [editMode, setEditMode] = useState(false); // State to track if in edit mode
  const toggleDiv1 = () => setIsDiv1Open(!isDiv1Open);
  const toggleDiv2 = () => setIsDiv2Open(!isDiv2Open);
  const gridRef1 = useRef(null);



  const fetchData = async () => {
    await fetchFieldInfo(54, setFields2, setColumnDefs2);
    await fetchFieldInfo(81, setFields2, setColumnDefs3);
    await fetchFieldInfo(34, setFields, setColumnDefs);
    await fetchFieldInfo(53, setFields2, setColumnDefs1);
    await fetchFieldInfo(36, setFields3, setColumnDefs); 
    await fetchFieldInfo(81, setFields1, setColumnDefs);
   setLoading(false); // Stop loading after fetching all field info
  };

  const fetchData2 = async () => {
    fetchFieldInfo2();
    setLoading(false); // Stop loading after fetching all field info
  };


  useEffect(() => {
  fetchData();
  fetchFieldInfo2();
  }, []);

  const getFormattedDate = () => {
    const currentDate = new Date();
    return currentDate.toISOString().slice(0, 19).replace("T", " ");
  };

  const formatColumnName = (name) =>
    name.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());

const handleTabChange1 = (index) => {
  setActiveTab(index);
  console.log("User switched to tab:", index);
  
  // Perform specific logic based on tab
  if (index === 0) {
    // View Purchase Orders tab
    fetchData2();
  } else if (index === 1) {
    // Purchase Order File Upload tab
    fetchFieldInfo3();
  } else if (index === 2) {
    // Purchase Order File Upload tab
    fetchFieldInfo4();
  }
};


 const fetchFieldInfo = async (headerConfigId, setFieldsFunc, setColumnDefsFunc) => {
  const payload = { headerconfig_id: headerConfigId,filterconditions: filterconditions};
  
    try {
      const FileUploadCredentials = Fetchheaderdata();
      const response = await axios.post(
        FileUploadCredentials[1], 
        payload, 
        FileUploadCredentials[0]
      );
  
      const data = response.data;
      console.log("fetched data",data)

      if (data.fields?.length) {
        const columns = data.fields.map((field) => ({
          headerName: formatColumnName(field.columnName),
          field: field.columnName,
          sortable: true,
          filter: true,
          resizable: true

        }));
	if (headerConfigId === 54){
        columns.push({
          headerName: "View",
          field: "edit",
          cellRendererFramework: (params) => (
    <Icon
      name="eye"
      style={{ cursor: 'pointer' }}
      onClick={() => handleEditClick(params.data)}
    />
          ),
          width: 100, // Set width for the edit column
        });} else if (headerConfigId === 81){
        columns.unshift({
        headerCheckboxSelection: true, // Add this line for the checkbox selection
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true, // Add this line for the checkbox selection
        width: 20
      },
     );}

        setColumnDefsFunc(columns);
        setFieldsFunc(data.fields);
        console.log("updation completed")
        return { fields: data.fields };
      }
    } catch (error) {
      console.error(`Error fetching field info for headerConfigId ${headerConfigId}:`, error);
      setError("Error fetching fields data");
        return { fields: []};
    }
  };
    

  const handleEditClick = async(row) => {
    console.log(row)
    const payload = { query: `SELECT * from payments.stg_paid_invoices where stg_setting_value = ${row.file_uploads_id}` };

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;
      if (data && data.length > 0) {
        const columns = Object.keys(data[0]).map((key) => ({
          headerName: formatColumnName(key),
          field: key,
        }));

        setRowData2(data);
        setShowPopup(true);

        console.log("data fetched",data)
      }
    } catch (error) {
      console.error("Error fetching department data:", error);
      setError("Error fetching department data");
    }
  };


  const fetchFieldInfo2 = async () => {
    const payload = { query: `SELECT (@row_number := @row_number + 1) AS 'sl_no', unique_number, IFNULL(TRIM(vendor_code), '') AS 'vendor_code', IFNULL(TRIM(vendor_name), '') AS 'vendor_name', IFNULL(TRIM(invoice_number), '') AS 'invoice_number', IFNULL(CONVERT(total_invoice_amount, CHAR), '0.00') AS 'invoice_amount', '' AS 'utr_number', '' AS 'payment_date', '' AS 'paid_amount', '' AS 'part_or_full_payments', '' AS 'Comments', '' AS 'batch_no', '' AS 'posting_date', IFNULL(DATE_FORMAT(finance_approval_date, '%d-%m-%Y'), '') AS 'finance_approval_date',id as approved_invoice_id FROM payments.approved_invoices, (SELECT @row_number := 0) AS t WHERE is_active = 1 AND is_paid = 0 AND is_finance_approved = 1 AND invoice_type IN (SELECT name 
        FROM user_management_uat.divisions 
        WHERE division_id IN (${divisionid})) AND entity_id = '${userCredentials.selectedentity}' order by unique_number;` };

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;
      if (data && data.length > 0) {
        const columns = Object.keys(data[0]).map((key) => ({
          headerName: formatColumnName(key),
          field: key,
        }));

        setRowData(data);
        console.log("data fetched",data)
      }
    } catch (error) {
      console.error("Error fetching department data:", error);
      setError("Error fetching department data");
    }
  };

  const fetchFieldInfo3 = async () => {
    const payload = { query: `SELECT file_uploads_id,IFNULL(TRIM(file_name), '') AS 'file_name', IFNULL(CONVERT(file_size, CHAR), '0') AS 'file_size_bytes', IFNULL(TRIM(status), '') AS 'status', IFNULL(TRIM(comments), '') AS 'comments', DATE_FORMAT(uploaded_time, '%d-%m-%Y %H:%i:%s') AS 'created_on' FROM process_data.file_uploads WHERE source_id = 208 and is_active = 1 AND entities_id = ${userCredentials.selectedentity} ORDER BY file_uploads_id DESC LIMIT 30;` };

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;
      if (data && data.length > 0) {
        const columns = Object.keys(data[0]).map((key) => ({
          headerName: formatColumnName(key),
          field: key,
        }));

        setRowData1(data);
        console.log("data fetched",data)
      }
    } catch (error) {
      console.error("Error fetching department data:", error);
      setError("Error fetching department data");
    }
  };

  const fetchFieldInfo4 = async () => {
const payload = {
  query: `
    SELECT
      (@row_number := @row_number + 1) AS sl_no,IFNULL(TRIM(ai.vendor_code), '') AS vendor_code,
      IFNULL(TRIM(ai.vendor_name), '') AS vendor_name,
      IFNULL(TRIM(ai.place_of_supply),'') AS place_of_supply,
      IFNULL(TRIM(ai.purchase_order_number), '') AS purchase_order_number,
      IFNULL(TRIM(ai.invoice_number), '') AS invoice_number,
      IFNULL(DATE_FORMAT(ai.invoice_date, '%d-%m-%Y'), '') AS invoice_date,
      IFNULL(CONVERT(ai.cgst_amount, CHAR), '0.00') AS cgst_amount,
      IFNULL(CONVERT(ai.sgst_amount, CHAR), '0.00') AS sgst_amount,
      IFNULL(CONVERT(ai.igst_amount, CHAR), '0.00') AS igst_amount,
      IFNULL(CONVERT(ai.invoice_amount, CHAR), '0.00') AS invoice_amount,
      IFNULL(CONVERT(ai.total_invoice_amount, CHAR), '0.00') AS total_invoice_amount,
      IFNULL(TRIM(pi.utr_number), '') AS utr_number,
      IFNULL(DATE_FORMAT(pi.payment_date, '%d-%m-%Y'), '') AS payment_date,
      IFNULL(CONVERT(pi.paid_amount, CHAR), '0.00') AS paid_amount,
      IFNULL(TRIM(ai.cost_center_code), '') AS cost_center_code,
      IFNULL(TRIM(ai.expense_code), '') AS expense_code,
      IFNULL(TRIM(ai.expense_category), '') AS expense_category,
      IFNULL(TRIM(ai.invoice_type), '') AS invoice_type,
      IFNULL(TRIM(ai.unique_number), '') AS unique_number,
      IFNULL(TRIM(ai.invoice_user_mail_id), '') AS \`Purchase User\`,
      IFNULL(TRIM(ai.approver_mail_id),'') AS \`Approver\`,
      IFNULL(TRIM(ai.finance_approved_by), '') AS \`Finance Approver\`,
      IFNULL(TRIM(ai.sbi_inv_no), '') AS \`SBI Invoice Number\`,
      IFNULL(CONVERT(ai.gst_bill_amount, CHAR), '0.00') AS \`Billed GST Amount\`,
      IFNULL(TRIM(pi.Comments), '') AS Comments,
      IFNULL(TRIM(pi.batch_no), '') AS batch_no,pi.part_or_full_payments,
      IFNULL(DATE_FORMAT(pi.posting_date, '%d-%m-%Y'), '') AS posting_date,IFNULL(DATE_FORMAT(ai.finance_approval_date, '%d-%m-%Y'), '') AS finance_approval_date
    FROM (SELECT @row_number := 0) AS t
    CROSS JOIN (
        SELECT
          id,vendor_code,
          vendor_name,
          place_of_supply,
          purchase_order_number,
          invoice_number,
          invoice_date,
          cgst_amount,
          sgst_amount,
          igst_amount,
          invoice_amount,
          total_invoice_amount,
          cost_center_code,
          expense_code,
          expense_category,
          invoice_type,
          unique_number,
          invoice_user_mail_id,
          approver_mail_id,
          finance_approved_by,finance_approval_date,
          sbi_inv_no,
          gst_bill_amount
        FROM payments.approved_invoices
        WHERE invoice_status IN ('PAID', 'PARTLY PAID')
          AND entity_id = '${userCredentials.selectedentity}'
          AND invoice_type IN (
            SELECT name
            FROM user_management_uat.divisions
            WHERE division_id IN (${divisionid})
          )
    ) ai
    INNER JOIN (
        SELECT
          utr_number,
          approved_invoice_id,
          payment_date,
          paid_amount,
          Comments,
          batch_no,part_or_full_payments,
          posting_date
        FROM payments.paid_invoices
        WHERE is_active = 1
    ) pi
      ON ai.id = pi.approved_invoice_id;
  `
};

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;
      if (data && data.length > 0) {
        const columns = Object.keys(data[0]).map((key) => ({
          headerName: formatColumnName(key),
          field: key,
        }));
        setRowData3(data);
      }
    } catch (error) {
      console.error("Error fetching department data:", error);
      setError("Error fetching department data");
    }
  };



const gridRef = useRef();

const onBtnExportCSV = () => {
  gridRef.current.api.exportDataAsCsv();
};

const onBtnExportCSV1 = () => {
  gridRef1.current.api.exportDataAsCsv();
};


const exportToPDF = () => {
  const filteredColumns = columnDefs1.filter((col) => col.field !== "id"); // Exclude 'id'
  const tableColumn = filteredColumns.map((col) => col.headerName);

  const gridApi = gridRef.current.api;
  const displayedRows = [];
  gridApi.forEachNodeAfterFilter((node) => {
    displayedRows.push(node.data); // Get filtered rows
  });

  const tableRows = displayedRows.map((row) =>
    filteredColumns.map((col) =>
      row[col.field] !== undefined && row[col.field] !== null ? String(row[col.field]) : ''
    )
  );

  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a3", // A3 landscape for more width
  });

  // Add logo
  const imgWidth = 28;
  const imgHeight = 14;
  const imgX = 10;
  const imgY = 5;
  doc.addImage(logo, "PNG", imgX, imgY, imgWidth, imgHeight);

  // Add title
  doc.setFontSize(14);
  doc.text("Purchase Order Report", 150, 15); // Adjust X for center alignment

  // Draw the table
  doc.autoTable({
    head: [tableColumn],
    body: tableRows,
    startY: 25,
    theme: "grid",
    styles: {
      fontSize: 4,
      cellPadding: 1,
      overflow: 'linebreak',
    },
    headStyles: {
      fillColor: [10, 35, 82],
      textColor: 255,
      fontSize: 5,
    },
    columnStyles: {
      // Optional: You can dynamically assign width or wrap style if needed
      // 0: { cellWidth: 25 },
    },
    margin: { top: 25, left: 5, right: 5 },
    didDrawPage: (data) => {
      const pageCount = doc.internal.getNumberOfPages();
      doc.setFontSize(5);
      doc.text(
        `Page ${data.pageNumber} of ${pageCount}`,
        data.settings.margin.left,
        doc.internal.pageSize.height - 10
      );
    },
  });

  doc.save("paid_invoices.pdf");
};

const exportToPDF1 = () => {
  const filteredColumns = columnDefs1.filter((col) => col.field !== "id"); // Exclude 'id'
  const tableColumn = filteredColumns.map((col) => col.headerName);

  const gridApi = gridRef1.current.api;
  const displayedRows = [];
  gridApi.forEachNodeAfterFilter((node) => {
    displayedRows.push(node.data); // Get filtered rows
  });

  const tableRows = displayedRows.map((row) =>
    filteredColumns.map((col) =>
      row[col.field] !== undefined && row[col.field] !== null ? String(row[col.field]) : ''
    )
  );

  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a3", // A3 landscape for more width
  });

  // Add logo
  const imgWidth = 28;
  const imgHeight = 14;
  const imgX = 10;
  const imgY = 5;
  doc.addImage(logo, "PNG", imgX, imgY, imgWidth, imgHeight);

  // Add title
  doc.setFontSize(14);
  doc.text("Purchase Order Report", 150, 15); // Adjust X for center alignment

  // Draw the table
  doc.autoTable({
    head: [tableColumn],
    body: tableRows,
    startY: 25,
    theme: "grid",
    styles: {
      fontSize: 4,
      cellPadding: 1,
      overflow: 'linebreak',
    },
    headStyles: {
      fillColor: [10, 35, 82],
      textColor: 255,
      fontSize: 5,
    },
    columnStyles: {
      // Optional: You can dynamically assign width or wrap style if needed
      // 0: { cellWidth: 25 },
    },
    margin: { top: 25, left: 5, right: 5 },
    didDrawPage: (data) => {
      const pageCount = doc.internal.getNumberOfPages();
      doc.setFontSize(5);
      doc.text(
        `Page ${data.pageNumber} of ${pageCount}`,
        data.settings.margin.left,
        doc.internal.pageSize.height - 10
      );
    },
  });

  doc.save("paid_invoices.pdf");
};



  const createPayload = (database, table, formData) => ({
    database,
    table,
    formData,
  });

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

const formatDateTime = (date) => {
  if (!date) return '';
  const d = new Date(date);
  const pad = (n, size = 2) => String(n).padStart(size, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
         `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.000000`;
};

const handleCreate = async () => {
  const formattedDate = getFormattedDate();
  console.log("PO formData", formData);

  // Build list_values consistently
  const listValue = [
    formData.purchase_order_number,
    formatDateTime(formData.po_date),
    formatDateTime(formData.po_expiry_date),userCredentials.selectedentity
  ].join("|");  // ? match DB format with spaces

  // Step 1: Check if record already exists
  const checkPayload = { 
    query: `SELECT * 
            FROM payments.purchase_order 
            WHERE list_values = '${listValue}';` 
  };

  try {
    const checkCredentials = Fetchexecutequery();
    const checkResponse = await axios.post(
      checkCredentials[1],
      checkPayload,
      checkCredentials[0]
    );

    const data = checkResponse.data;

    // Step 2: Only create if record not found
    if (data.length === 0) {
      const updatedFormData = {
        ...formData,
        created_on: formattedDate,
        last_updated_on: formattedDate,
        entity_id: userCredentials.selectedentity,
        created_by: userCredentials.user_id,
        modified_by: userCredentials.user_id,
        last_updated_by: userCredentials.user_name,
        is_purchase_order: 1,
        is_milestone_added: 0,
        list_values: listValue
      };

      const createPayloadData = createPayload(
        'payments',
        'purchase_order',
        updatedFormData
      );

      const createCredentials = CreateData();

      const createResponse = await axios.post(
        createCredentials[1],
        createPayloadData,
        createCredentials[0]
      );

      console.log("Create response:", createResponse);
      window.location.reload();
    } else {
      alert("Duplicate entry: PO already exists with same PO number");
    }
  } catch (error) {
    console.error("Error in handleCreate:", error);
    setError("Error creating data");
  }
};

  const handleUpdate = () => {

    const formattedDate = getFormattedDate();
    const updatedFormData = { ...formData,
        last_updated_on: formattedDate,
        modified_by: userCredentials.user_id,
        last_updated_by: userCredentials.user_name
 };

    // Remove primary_id from the copied formData
    delete updatedFormData.primary_id;
    const payload = {
      schema_name: 'payments',
      table: 'cost_centres',
      set_column : updatedFormData,
      'where' : [{"id":formData.id}]
    };

    const FileUploadCredentials = Fetchupdatequery();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Update response:", response);
        setEditMode(false); // Reset edit mode after updating
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error updating data:", error);
        setError("Error updating data");
      });
  };

  const handleInputChange = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const onFilterTextChange = (event) => {
    const { value } = event.target;
    setSearchText(value);
  };

const handleFileuploadSave = () => {
  const selectedRows = gridRef1.current.api.getSelectedRows();
  console.log("Selected Rows:", selectedRows);

  const selectedIds = selectedRows.map(row => row.id);

  if (selectedIds.length === 0) {
    alert("Please select at least one row.");
    return;
  }

    const payload = {
      'ids': selectedIds,
      'last_updated_by': userCredentials.user_name,  
    };

    const FileUploadCredentials = FetchsavePIRows();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(response => {
        console.log("Update response:", response);
	alert("Records Saved Successfully!!!");
	setShowPopup(false);
      })
      .catch((error) => {
        console.error("Error updating data:", error);
	alert("Error in Saving Records!!!");
        setError("Error updating data");
      });

};



const handlefileupload = () => {
  const formattedDate = getFormattedDate();

  const updatedFormData = {
    ...formData2,
    last_updated_on: formattedDate,
    modified_by: userCredentials.user_id,
    last_updated_by: userCredentials.user_name
  };
  console.log("updatedFormData",updatedFormData)

  const filePath = "/data/p2p/Production/Projects/TeamLease/PaymentsProcess/data/PurchaseOrder/input/";  // Update this with the actual value

  const payload = {
    ...updatedFormData,
    file_path: filePath,
    source_name: "YourSourceName",
    config_id: 20,
    month: "2024-12", // or from formData.month
    skiprows: 0,
    table: "stg_paid_invoices",
    tenants_id: userCredentials.tenants_id,
    groups_id: userCredentials.groups_id,
    entities_id: userCredentials.selectedentity,
    user_id: userCredentials.user_id,
    source_type: "utr_update",
    process_id:36
  };

  const FileUploadCredentials = Fetchfileupload();

  axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
    .then(response => {
      console.log("Upload response:", response);
      setEditMode(false);
      fetchFieldInfo3();
      window.location.reload();
    })
    .catch((error) => {
      console.error("Error uploading file:", error.response.data.error);
      setError(error.response.data.error);
    });
};


  const handleSubmit = (e) => {
    e.preventDefault();
    if (editMode) {
      handleUpdate();
    } else {
      handleCreate();
    }
  };

 if (loading) return <LoaderComponent loaderOpen={true}/>;

  return (
    <div>
      <h2 className="pt-1 pb-1 text-center" style={{ color: "#4969ab", fontSize: '18px' }}>
        Paid Invoice Details
      </h2>


            <Tabs selectedIndex={activeTab} onSelect={(index) => handleTabChange1(index)}>
        <TabList>
          <Tab>Approved Invoice Download</Tab>
          <Tab>Paid Invoice Details Upload</Tab>
          <Tab>Paid Invoices</Tab>
        </TabList>

      {error && <div style={{ color: "red" }}>{error}</div>}

       <TabPanel>
<div style = {{display:"flex",padding:"10px"}}>
<div>
  <img
    src={excelIcon}
    alt="Export to Excel"
    title="Download Excel"
    onClick={onBtnExportCSV1} // Attach Excel export function
    style={{
      width: '28px',
      height: '28px',
      cursor: 'pointer',
      marginRight: '8px',
    }}
  />
</div>
<div>
  {/* PDF Icon */}
  <Icon
    name="file pdf outline"
    title="Download PDF"
    onClick={exportToPDF1} // Attach PDF export function
    style={{
      fontSize: '28px',
      color: '#d9534f',
      cursor: 'pointer',
    }}
  />
</div>

</div>


          <div className="ag-theme-alpine" style={{
              overflowX: 'auto',
              overflowY: 'auto',
              borderRadius: '10px',
              width: `${4 * 400}px`,
              height : '600px'
         }}>
            <AgGridReact     
  ref={gridRef1}
  rowData={rowData}
  columnDefs={columnDefs3}
  pagination={true}
  paginationPageSize={8}
  filter={true}
  rowSelection="multiple" // or "single"
  suppressRowClickSelection={true}
  enableRangeSelection={true}
  suppressCopyRowsToClipboard={false}
            />
          </div>

        </TabPanel>
        <TabPanel>
           <DynamicForm fields={fields3} formData={formData2} onInputChange={(name, value) => {
              setFormData2((prev) => ({ ...prev, [name]: value }));
            }} />
            <div className="submit-row">
              <button type="submit" className="submit-btn" onClick={handlefileupload}>
                Upload
              </button>
            </div>
          <div className="ag-theme-alpine" style={{
              overflowX: 'auto',
              overflowY: 'auto',
              borderRadius: '10px',
              width: `${5 * 250}px`,
              height : '400px'
         }}>
            <AgGridReact
              rowData={rowData1}
              columnDefs={columnDefs2}
              pagination={true} // Enable pagination
              paginationPageSize={8} // Set the number of rows per page
              filter={true} // Enable filtering on the grid level
  rowSelection="multiple" // or "single"
  suppressRowClickSelection={true}
  enableRangeSelection={true}
  suppressCopyRowsToClipboard={false}

            />
          </div>

        </TabPanel>

        <TabPanel>

<div style = {{display:"flex",padding:"10px"}}>
<div>
  <img
    src={excelIcon}
    alt="Export to Excel"
    title="Download Excel"
    onClick={onBtnExportCSV} // Attach Excel export function
    style={{
      width: '28px',
      height: '28px',
      cursor: 'pointer',
      marginRight: '8px',
    }}
  />
</div>
<div>
  {/* PDF Icon */}
  <Icon
    name="file pdf outline"
    title="Download PDF"
    onClick={exportToPDF} // Attach PDF export function
    style={{
      fontSize: '28px',
      color: '#d9534f',
      cursor: 'pointer',
    }}
  />
</div>

</div>

          <div className="ag-theme-alpine" style={{height:'690px',width: '1780px',borderRadius:'8px' }}>
            <AgGridReact
                ref={gridRef1}
  rowData={rowData3}
  columnDefs={columnDefs3}
  pagination={true}
rowHeight={40}
  paginationPageSize={15}
  filter={true}
  enableRangeSelection={true}
  suppressCopyRowsToClipboard={false}
 enableCellTextSelection={true} 
            />
          </div>
        </TabPanel>

      </Tabs>
{showPopup && (
  <>
    {/* Overlay */}
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 999
      }}
    />

    {/* Popup */}
    <div
      style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'white',
        borderRadius: '10px',
        boxShadow: '0 0 10px rgba(0,0,0,0.3)',
        zIndex: 1000,
        padding: '16px',
        minWidth: '400px'
      }}
    >

      {/* AG Grid */}
      <div
        className="ag-theme-alpine"
        style={{
          overflowX: 'auto',
          overflowY: 'auto',
          borderRadius: '10px',
          width: `${5 * 250}px`,
          height: '420px'
        }}
      >
<AgGridReact
  ref={gridRef1}
  rowData={rowData2}
  columnDefs={columnDefs3}
  pagination={true}
  paginationPageSize={8}
  filter={true}
  rowSelection="multiple" // or "single"
  suppressRowClickSelection={true}
  enableRangeSelection={true}
  suppressCopyRowsToClipboard={false}
/>

      </div>
<div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '16px' }}>
  <button type="submit" className="submit-btn" onClick={handleFileuploadSave}>
    Save
  </button>
  <button type="submit" className="submit-btn" onClick={() => setShowPopup(false)}>
    Close
  </button>
</div>

    </div>
  </>
)}

    </div>
  );
}

export default PoCreation;
